'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrintButton = /*#__PURE__*/function (_React$Component) {
  _inherits(PrintButton, _React$Component);

  function PrintButton(props) {
    _classCallCheck(this, PrintButton);

    return _possibleConstructorReturn(this, (PrintButton.__proto__ || Object.getPrototypeOf(PrintButton)).call(this, props));
  }

  _createClass(PrintButton, [{
    key: "render",
    value: function render() {
      var path = 'M19 8H18V3H6V8H5C3.33997 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8' + ' 5H16V8H8V5ZM16 19V17V15H8V19H16ZM18 15V13H6V15H4V11C4 10.45 4.44995 10 5 10H19C19.55 10 20 10.45 20' + ' 11V15H18ZM17 11.5C17 10.9477 17.4478 10.5 18 10.5C18.5522 10.5 19 10.9477 19 11.5C19 12.0523 18.5522' + ' 12.5 18 12.5C17.4478 12.5 17 12.0523 17 11.5Z';

      var svg = /*#__PURE__*/_react.default.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "icon/action/print_24px"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: path
      })));

      return this.props.isLink ? /*#__PURE__*/_react.default.createElement("a", {
        className: "large-button",
        href: this.props.href,
        target: this.props.target
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, this.props.text), /*#__PURE__*/_react.default.createElement("span", {
        className: "arrow"
      }, svg)) : /*#__PURE__*/_react.default.createElement("button", {
        className: "large-button",
        disabled: this.props.disabled
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text"
      }, this.props.text), /*#__PURE__*/_react.default.createElement("span", {
        className: "arrow"
      }, svg));
    }
  }]);

  return PrintButton;
}(_react.default.Component);

PrintButton.propTypes = {
  disabled: _propTypes.default.bool,
  isLink: _propTypes.default.bool,
  href: _propTypes.default.string,
  target: _propTypes.default.string,
  text: _propTypes.default.string
};
PrintButton.defaultProps = {
  text: '',
  disabled: false,
  isLink: false,
  href: '',
  target: '_blank'
};
var _default = PrintButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/print-button/index.js
// module id = 555
// module chunks = 0